import { Mapper } from "../../../../base/utils/mapper";
import { ClasificationDiagnosticModel } from "../../../../domain/models/consult/clasification-diagnostic.model";
import { ClasificationDiagnosticEntity } from "../entities/clasification-diagnostic.entity";


export class ClasificationDiagnosticImplementationRepositoryMapper extends Mapper<ClasificationDiagnosticEntity, ClasificationDiagnosticModel> {
    mapFrom(param: ClasificationDiagnosticEntity): ClasificationDiagnosticModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ClasificationDiagnosticModel): ClasificationDiagnosticEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}